import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { awards } from 'constants/layout'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Award'
})
class Award extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    tabs: PropTypes.object.isRequired
  }

  render() {
    const { tabs, children } = this.props

    return (
      <div>
        {React.cloneElement(tabs, {
          links: awards.tabs
        })}
        {children}
      </div>
    )
  }
}

export default Award
